import { AUTH_TOKEN, ENVIRONMENT } from '../config/constants'

//Get Authentiacation Token
export const getToken = () => {
  const headers = JSON.parse(
    window.localStorage.getItem(AUTH_TOKEN) || JSON.stringify({ token: '' })
  )
  let token = headers.token ? `Bearer ${headers.token}` : null
  const sessionToken = headers.sessionToken || null
  return {token: token, sessionToken: sessionToken}
}

export function getEnvironmentFromLocalStorage() {
  const environmentData = localStorage.getItem(ENVIRONMENT)
  let environment = null
  if (environmentData) {
    environment = JSON.parse(environmentData)
  }
  return environment
}

export function getTimeZone() {
  return Intl.DateTimeFormat().resolvedOptions().timeZone
}

export function isAccessCookieExist(cookies = {}) {
  let keys = Object.keys(cookies)
  let isPresent = keys.some(ele => ele.includes('access_token'))
  return isPresent
}

export function changeEnv(apiUrl = 'https://tpt-preprod.fareye.co') {
  let url = new URL(apiUrl)
  let urls: any = localStorage.getItem('environment')
  if (urls) {
    urls = (urls && JSON.parse(urls)) || {}
    urls.postUrl = url.host
    let excludeKeys = ['mapKey', 'defaultBaseLayer', 'postUrl', 'production']
    Object.entries(urls).forEach(([key, _]) => {
      if (!excludeKeys.includes(key)) {
        urls[key] = apiUrl
      }
    })
    localStorage.setItem('environment', JSON.stringify(urls))
  } else {
    console.warn('Environment is not created in localstorage')
  }
}
